<template>
  <div 
    data-gtm-action="scroll to Join Us Section" 
    @click="scrollToJoinUsSection"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
const scrollToJoinUsSection = () => {
  const targetElement = document.getElementById('careers-join-us')
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>
